import React, {useEffect} from 'react';
import {TouchableOpacity} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import {useNavigation, useRoute} from '@react-navigation/native';

import Text from '/component/base/Text';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Edge365CongratulationsScreen.style';

export const Edge365CongratulationsScreen = ({}: any) => {
  const {tt} = useTranslation('screen.Edge365_ThirdScreen');
  const navigation = useNavigation();
  const route = useRoute();
  const {completedDate} = route?.params as {completedDate: string};
  const formatDate = (dateString: string) => {
    const [year, month, day] = dateString
      .split('-')
      .map(num => parseInt(num, 10));
    const date = new Date(year, month - 1, day); // month is 0-indexed in JS Date
    return (
      date.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      }) + '!'
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigation.goBack();
    }, 5000); // 5000 milliseconds = 5 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <LinearGradient colors={['#6DD5A9', '#48C6EF']} style={styles.container}>
      <TouchableOpacity
        style={styles.closeButton}
        onPress={() => {
          navigation.goBack();
        }}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.closeButtonText}
          accessible={true}
          accessibilityLabel="close button">
          ✕
        </Text>
      </TouchableOpacity>
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        style={styles.title}
        isBold
        testID="congratulations-title"
        accessible={true}>
        {tt('congratulations', 'Congratulations!')}
      </Text>
      <Text
        allowFontScaling
        maxFontSizeMultiplier={2}
        style={styles.subtitle}
        isBold
        testID="congratulations-subtitle"
        accessible={true}>
        You've completed your EDGE30{'\n'}tasks for {formatDate(completedDate)}
      </Text>
      <TouchableOpacity
        style={styles.button}
        onPress={() => {
          navigation.goBack();
        }}
        testID="awesome-button">
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.buttonText}
          isBold
          accessible={true}>
          {tt('awesome', 'Awesome!')}
        </Text>
      </TouchableOpacity>
    </LinearGradient>
  );
};
